import React, {forwardRef, memo} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import {GridProps} from "@mui/material"
import connect from "./connect"

export interface StyledProductGridWrapperProps extends GridProps {
    largertoppaddingdesktop?: boolean
    isSearchBannerEnabled?: boolean
    isAutocorrected: boolean
    urlIsSaleOrClearance: boolean
    templating: {mainTemplate: string; fallbackTemplate: string}
}

const StyledProductGridWrapper = memo(
    forwardRef(({templating, ...props}: StyledProductGridWrapperProps, ref) => {
        const ComponentName = useTemplatedComponent(templating, MANIFEST)

        return <ComponentName ref={ref} {...props} />
    }),
)

StyledProductGridWrapper.displayName = "StyledProductGridWrapper"

export default connect(StyledProductGridWrapper)
